import { ActionIcon, Center, Flex, Text } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

import { COLORS } from '@/utils/colors';

type Props = {
  onClick?: () => void;
  isLoading?: boolean;
  size?: number;
  text?: string;
  ariaLabel?: string;
};

export const AddButton = ({ onClick, isLoading, size = 100, text, ariaLabel }: Props) => {
  return (
    <Center>
      <ActionIcon
        variant="filled"
        radius="lg"
        loading={Boolean(isLoading)}
        m="xs"
        size={Number(size)}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        <Flex direction="column" align="center" justify="center">
          <IconPlus color={COLORS.primary} size={40} />
          {text && (
            <Text size="xs" ta="center">
              {text}
            </Text>
          )}
        </Flex>
      </ActionIcon>
    </Center>
  );
};
